<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img src="@/assets/logo.png" class="my-3" contain height="200" />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">Sistem Pakar</h1>

        <p class="subheading font-weight-regular">
          Penyakit Tanaman Singkong Berbasis
          <i>
            <b>Forward Chaining</b>
          </i>
        </p>
      </v-col>

      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">Anda petani ?</h2>

        <v-row justify="center">
          <prediksi />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import prediksi from "@/components/PrediksiForm.vue";
export default {
  components: { prediksi },
  data() {
    return {};
  }
};
</script>